import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { pickHTMLProps } from 'pick-react-known-prop';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(
  (theme) => ({
    root: {},
    tagContainer: {
      padding: theme.spacing(0, 1),
      '& img': {
        width: 100,
        height: 100,
        // margin: theme.spacing(0, 1.5),
        [theme.breakpoints.down('sm')]: { width: 70, height: 70, margin: theme.spacing(0, 1.25) },
      },
    },
  }),
  { name: 'ProductDetailCertificate' },
);

function ProductDetailCertificate({ classes: pClasses, className, ...rest }) {
  const classes = useStyles({ classes: pClasses });

  return (
    <div {...pickHTMLProps(rest)} className={clsx(classes.root, className)}>
      <div
        className={classes.tagContainer}
        style={{ background: 'transparent', textAlign: 'center', padding: 0, margin: '0 auto' }}
      >
        <a
          title='Compari.ro - ghid autentic de shopping'
          href='https://www.compari.ro/stores/digiexpert-s125873/#pareri-or10of0fr-1fm-1'
        >
          <img
            src='https://image.compari.ro/trustedbadge/125873-100x100-44608a78805a9a010b861d77a07d9797.png'
            alt='Compari.ro - ghid autentic de shopping'
            style={{ borderStyle: 'none' }}
          />
        </a>
      </div>
    </div>
  );
}

ProductDetailCertificate.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    tagContainer: PropTypes.string,
  }),
  className: PropTypes.string,
};

ProductDetailCertificate.defaultProps = {
  classes: undefined,
  className: undefined,
};

export default ProductDetailCertificate;
